export interface CalculationResult {
  tong_tien: number;
  thue: number;
}

export function calculateTotals(detailItems: BanHangRecord[] = []): CalculationResult {
  const tong_tien = detailItems.reduce((sum, item) => sum + (parseFloat(item.tien_nt2) || 0), 0);
  const thue = detailItems.reduce((sum, item) => sum + (parseFloat(item.thue_nt) || 0), 0);

  return {
    tong_tien,
    thue
  };
}

export const handleUpdateRowFields = (
  row: BanHangRecord,
  field: string,
  newValue: BanHangValue
): Partial<BanHangRecord> => {
  if (field === 'so_luong' || field === 'gia_nt2' || field === 'tl_ck' || field === 'ma_thue_data') {
    const so_luong = field === 'so_luong' ? newValue : row.so_luong;
    const gia_nt2 = field === 'gia_nt2' ? newValue : row.gia_nt2;
    const thue_suat = field === 'ma_thue_data' ? newValue?.thue_suat || 0 : row.ma_thue_data?.thue_suat || 0;

    const tien_nt2 = (Number(so_luong) || 0) * (Number(gia_nt2) || 0);
    const thue_nt = (tien_nt2 * (Number(thue_suat) || 0)) / 100;

    return {
      tien_nt2,
      thue_nt
    };
  }
  return {};
};
